
import { View } from 'backbone';
import eventBus         from 'EventBus.js';

import BaseControlView from 'BaseControlView.js';
import constants        from "Constants.js";
import template from 'advanced-inputs/control_web_signature.ejs';
//=====================================================================
//
// An instance of this view represents a Ranking control.
//
// Alfonso Cabral, March 11, 2016
//
//=====================================================================
class WebSignatureControlView extends BaseControlView  {

    initialize( opts ) {
        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_ADVANCED_INPUTS;
        this.subfamily = constants.CONTROL_ATTACHMENTS;
        this.icon = 'pf-web-signature';

        this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'BaseStaticTextControl';
    }

}

export default WebSignatureControlView;
